export const GLOBAL_STATE = 'Report'

export const REPORT = 'REPORT' as const
export const REPORT_CREATE = 'REPORT_CREATE' as const
// export const REPORT_ALL = 'REPORT_ALL' as const
export const REPORT_LIST = 'REPORT_LIST' as const
export const REPORT_FIELDS = 'REPORT_FIELDS' as const
export const REPORT_FIELDS_FILTER = 'REPORT_FIELDS_FILTER' as const
